module.exports = __webpack_public_path__ + "media/images/client_certificate_selection/certificates_in_ie_select-3cfb179a10f917ad7ecde1ee89332082.jpg";